<template>
  <div class="d-flex">
    <div
      v-if="average"
      class="w-50 statistic-container"
    >
      <div class="statistic d-flex">
        {{ average.toFixed(1) }}
        <div v-if="averageTotal">
          <img
            v-if="average.toFixed(1) > averageTotal.toFixed(1)"
            src="@/common/assets/img/arrow-up.svg"
            alt="arrow-up"
            class="arrow"
          />
          <img
            v-else-if="average.toFixed(1) < averageTotal.toFixed(1)"
            src="@/common/assets/img/arrow-down.svg"
            alt="arrow-up"
            class="arrow"
          />
        </div>
      </div>
      <div class="statistic-label">
        {{ averageRatingLabel }}
      </div>
    </div>
    <div
      v-else-if="hasDates"
      class="w-50 statistic-container"
    >
      <div
        class="statistic-sm"
        v-if="endDate"
      >
        {{ toPrettyDate(startDate) }}
      </div>
      <div
        class="statistic-label"
        v-if="hasDates"
      >
        -
      </div>
      <div
        class="statistic-sm"
        v-if="endDate"
      >
        {{ toPrettyDate(endDate) }}
      </div>
    </div>
    <div
      class="w-50 statistic-container"
      :class="{'w-50': hasDatesOrAverage, 'w-100': !hasDatesOrAverage}"
    >
      <div class="statistic d-flex align-items-center">
        <div>
          {{ numberOfReviews }}
        </div>

        <div v-if="groupSize" class="ml-2 statistic-small">/ {{groupSize}}</div>
      </div>
      <div class="statistic-label">
        {{ numberOfReviewsLabel }}
      </div>
    </div>
  </div>
</template>

<script>
import VueI18n from '@/i18n';
import { toPrettyDate } from '@/common/utils/formatting';

const t = (key) => VueI18n.t(key);

export default {
  name: 'ResearchInfo',
  props: {
    average: {
      type: Number,
      required: false,
    },
    averageTotal: {
      type: Number,
      required: false,
    },
    numberOfReviews: {
      type: Number,
      required: true,
    },
    groupSize: {
      type: Number,
      required: false,
    },
    startDate: {
      type: Date,
      required: false,
    },
    endDate: {
      type: Date,
      required: false,
    },
  },
  methods: {
    toPrettyDate,
  },
  computed: {
    hasDates() {
      return this.startDate && this.endDate;
    },
    hasDatesOrAverage() {
      return this.hasDates || this.average;
    },
    averageRatingLabel() {
      return t('word.grade');
    },
    numberOfReviewsLabel() {
      return t('word.reviews');
    },
  },
};
</script>

<style scoped>
.statistic-container {
  height: 130px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

div.statistic {
  font-size: 30px;
}

div.statistic-small {
  font-size: 17px;
}

div.statistic-sm {
  font-size: 15px;
}

.arrow {
  width: 25px;
  height: 25px;
  margin-left: 5px;
  margin-bottom: 5px;
}
</style>
